import { Box, Icon, Paper, Typography } from "@mui/material";
import React from "react";
import { customColors, theme } from "theme";
import { FormaPagamentoCardProps } from "./formapagamento.model";
import './formapagamento.style.css';

export const FormaPagamentoCard = (props: FormaPagamentoCardProps) => {
    return (
        <Box
            sx={{
                borderRadius: '23px',
                padding: '3px',
                position: 'relative',
                overflow: 'hidden',
                '&::after': {
                    position: 'absolute',
                    width: 'calc(200%)',
                    height: '60%',
                    top: '50%',
                    left: '-50%',
                    transform: 'translateY(-50%)',
                    background: theme.palette.primary.main,
                    content: "''",
                    display: props.hasCreditoCliente && !props.disabled ? 'flex' : 'none',
                    zIndex: -1,
                    animation: 'rotate 3s linear infinite'
                }
            }}
        >
            <Paper
                id={props.id ? props.id.toLowerCase() + '-card' : undefined}
                elevation={2}
                sx={{
                    minWidth: { xs: 100, sm: 100, md: 200 },
                    height: props.height ?? 78,
                    background: props.disabled ? customColors.cinzaClaro : '',
                    '&:hover': {
                        background: props.disabled ? '' : theme.palette.background.default,
                        filter: !props.disabled ? 'brightness(.9)' : ''
                    },
                    color: theme.palette.text.primary,
                    cursor: props.disabled ? 'auto' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '15px',
                    padding: '15px',
                    borderRadius: '20px',
                }}
                onClick={!props.disabled ? () => props.onClick!(props.id) : undefined}
            >
                {props.icon.component ? (
                    React.cloneElement(props.icon.component, {
                        sx: {
                            fontSize: '36px',
                            width: '40px',
                            color: props.disabled ? theme.palette.text.disabled : theme.palette.primary.main,
                        },
                    })
                ) : (
                    <Icon
                        className={`${props.icon.type ?? 'fa-solid'} ${props.icon.name}`}
                        sx={{
                            fontSize: '30px',
                            width: '40px',
                            color: props.disabled ? theme.palette.text.disabled : theme.palette.primary.main,
                        }}
                    />
                )}
                <Typography
                    sx={{
                        width: '100%',
                        textAlign: 'center',
                        userSelect: 'none',
                    }}
                >
                    {props.label}
                </Typography>
            </Paper>
        </Box>
    );

};
